<mat-toolbar class="header">
  <span class="title">Logs</span>
  <span class="example-spacer"></span>

  @if (activeTab() === 'company') {
    <app-select
      class="company-select"
      placeholder="Company"
      [options]="companyOptions()"
      [value]="selectedCompanyId()"
      (valueChange)="changeCompany($event)" />
  }

  <div class="buttons">
    <app-button
      ariaLabel="Filters"
      class="icon"
      [openFilter]="filterOptionsService.getOptions()">
      <mat-icon>filter_alt</mat-icon>
    </app-button>
  </div>
</mat-toolbar>

<app-tabs
  appearance="underline"
  ariaLabel="Log type"
  [selectedTab]="activeTab()"
  (selectedTabChange)="changeTab($event)">
  <app-tab
    value="company"
    label="Company" />
  <app-tab
    value="admin"
    label="Admin" />
</app-tabs>
